import React from 'react'
import { Button, Col, Container, ListGroup, Row } from 'react-bootstrap';

const Footer = () => {
    return (
        <footer className='text-center footer py-5'>
            <Container>
                <Row>
                    <Col md={4}>
                        <h4 className='text-uppercase'>Location</h4>
                        <p className='lead'>3131 NE 7th Ave<br/>Miami, FL 33137</p>
                    </Col>
                    <Col md={4}>
                        <h4 className='text-uppercase'>Around the Web</h4>
                        <ListGroup horizontal className='bg-transparent d-flex justify-content-center'>
                            <ListGroup.Item className='bg-transparent border-0'>
                                <a href='https://www.linkedin.com/in/maxim-kapelina' target='_blank' rel='noreferrer noopener'>
                                    <Button className='text-center btn-social rounded-circle'>
                                        <i className='fa fa-linkedin fa-fw'/>
                                    </Button>
                                </a>
                            </ListGroup.Item>
                            <ListGroup.Item className='bg-transparent border-0'>
                                <a href='https://www.github.com/mkapelina' target='_blank' rel='noreferrer noopener'>
                                    <Button className='text-center btn-social rounded-circle'>
                                        <i className='fa fa-github fa-fw'/>
                                    </Button>
                                </a>
                            </ListGroup.Item>
                        </ListGroup>
                    </Col>
                    <Col md={4}>
                        <h4 className='text-uppercase mb-2'>Maxim Kapelina</h4>
                        <p className='lead mb-0'><span>Maximizing efficiency through leadership in Software Development</span></p>
                    </Col>
                </Row>
            </Container>
            <small>Copyright &copy;Maxim Kapelina {new Date().getFullYear()}</small>
        </footer>
    )
}

export default Footer;